import styled from 'react-emotion'

const Button = styled('button')({
    fontFamily: 'Montserrat, sans-serif',
    padding: '15px 30px',
    boxShadow: '0 15px 35px rgba(50,50,93,0.1), 0 5px 15px rgba(0,0,0,0.07)',
    fontWeight: 700,
    fontSize: 18,
    textTransform: 'uppercase',
    color: '#fff',
    background: 'linear-gradient(120deg, #F06F2F, #d04d0d)',
    borderRadius: 4,
    border: 0,
    outline: 0,
    float: 'right',
    transition: 'transform 250ms',
    ':hover': {
        cursor: 'pointer',
        background: 'rgba(240,111,47,0.75)',
        transform: 'scale(1.10)'
    },
    ':focus': {
        borderColor: '#F06F2F',
        boxShadow:
            '0 15px 35px rgba(50,50,93,0.1), 0 5px 15px rgba(0,0,0,0.07), 0 0 0 0.2rem rgba(240,111,47,0.25)'
    },
    ':active': {
        background: 'linear-gradient(120deg, #F06F2F, #d04d0d)'
    },
    ':disabled': {
        background: 'rgba(142, 142, 142, .5)'
    },
    '@media (max-width: 500px)': {
        fontSize: 15,
        float: 'left'
    }
})

export default Button


// WEBPACK FOOTER //
// ./src/components/ButtonComponent.jsx